import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=3b8b88be&scoped=true&"
import script from "./message-list.vue?vue&type=script&lang=js&"
export * from "./message-list.vue?vue&type=script&lang=js&"
import style0 from "./message-list.vue?vue&type=style&index=0&id=3b8b88be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b88be",
  null
  
)

export default component.exports